function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import { AppContext } from 'context';
import history from 'helpers/history';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import BackButton from 'components/BackButton';
import Tabs from 'components/Tabs';
import App, { AlertsBus } from 'modules/App';
import Account, { ElevatePermissionsModal } from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './ClinicSettings.pcss';
import ClinicMemberships from './ClinicMemberships';
import DataSettings from './DataSettings';
import PhiSettings from './PhiSettings';
var _React_PureComponent;
class ClinicSettings extends (_React_PureComponent = React.PureComponent) {
    onChangeView(view) {
        const { activeClinicMembership } = this.props;
        const organizationUID = get(activeClinicMembership, 'clinic.organizationUID');
        const clinicName = get(activeClinicMembership, 'clinic.name');
        const clinicSlug = getSlug(clinicName);
        const url = view === 'memberships' ? this.context.getUrl('clinic-settings', {
            clinicSlug,
            organizationUID
        }) : this.context.getUrl('clinic-settings-view', {
            clinicSlug,
            organizationUID,
            view
        });
        history.push(url);
    }
    onFetchClinicMemberships() {
        if (process.env.BROWSER && !this.props.isClientInitialized) {
            return;
        }
        const { clinicId } = this.clinic;
        this.props.onFetchClinicMemberships(clinicId);
    }
    /*
  async onOpenMenu(evt, item) {
    evt.preventDefault();
    const { clinicHcpMembershipId, identityUID } = item;
    await this.props.onCloseDropdown();
    this.props.onOpenDropdown(`${constants.CLINIC_MEMBERSHIP_DROPDOWN}-${clinicHcpMembershipId || identityUID}`);
  }
 */ get backUrl() {
        const { organizationUID } = this.props;
        const { previousName, previousParams } = this.props.route;
        if (previousName === 'account-settings') {
            return this.context.getUrl(previousName, previousParams);
        }
        return this.context.getUrl('general-population', {
            clinicSlug: getSlug(this.clinic.name),
            organizationUID
        });
    }
    get clinicMembership() {
        if (this._clinicMembership) {
            return this._clinicMembership;
        }
        const { organizationUID, hcpClinicMemberships } = this.props;
        this._clinicMembership = find(hcpClinicMemberships, (membership)=>membership.clinic.organizationUID === organizationUID);
        return this._clinicMembership;
    }
    get clinic() {
        if (this._clinic) {
            return this._clinic;
        }
        this._clinic = get(this.clinicMembership, 'clinic', {});
        return this._clinic;
    }
    get country() {
        const { countryCode: alpha2Code } = this.clinic;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
    }
    renderView() {
        const { view, activeClinicMembership, clinicMemberships } = this.props;
        if (view === 'phiSettings') {
            return /*#__PURE__*/ _jsx(PhiSettings, {
                activeClinicMembership: activeClinicMembership
            });
        }
        if (view === 'dataSettings') {
            return /*#__PURE__*/ _jsx(DataSettings, {
                activeClinicMembership: activeClinicMembership,
                clinicMemberships: clinicMemberships
            });
        }
        return /*#__PURE__*/ _jsx(ClinicMemberships, {
            activeClinicMembership: activeClinicMembership,
            clinicMemberships: clinicMemberships
        });
    }
    renderHeader() {
        const { name, logo, street, city, zipCode } = this.clinic;
        return /*#__PURE__*/ _jsxs("header", {
            className: "pageHeader d-flex align-items-center",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "d-block text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.clinicSettings))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.clinic,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(Avatar, {
                                avatarImg: logo,
                                name: name,
                                className: styles.clinic__logo,
                                imgClassName: styles.clinic__logo__img,
                                initialsClassName: styles.clinic__logo__initials
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: styles.clinic__name,
                                    children: name
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: styles.clinic__address,
                                    children: [
                                        this.country,
                                        ", ",
                                        street,
                                        ", ",
                                        city,
                                        " ",
                                        zipCode
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(BackButton, {
                    to: this.backUrl
                }),
                this.renderHeader(),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-8",
                    isGlobal: true
                }),
                /*#__PURE__*/ _jsx(Tabs, {
                    activeItem: this.props.view,
                    items: this.props.views,
                    messages: messages.nav,
                    action: (activeView)=>this.onChangeView(activeView)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-7 pt-6 mb-10",
                    children: this.renderView()
                }),
                /*#__PURE__*/ _jsx(ElevatePermissionsModal, {
                    actionMessage: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.editClinicSettings))
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this._clinicMembership = null;
        this._clinic = null;
        const { countryId } = this.clinic;
        props.onFetchCustomIdentifiers(countryId);
        this.onFetchClinicMemberships();
    }
}
_define_property(ClinicSettings, "contextType", AppContext);
_define_property(ClinicSettings, "propTypes", {
    // Explicit props
    organizationUID: PropTypes.string.isRequired,
    // Explicit props
    view: PropTypes.string,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    // Implicit props
    hcpClinicMemberships: PropTypes.arrayOf(Account.shapes.clinicMembership),
    activeClinicMembership: Account.shapes.clinicMembership,
    clinicMemberships: PropTypes.arrayOf(shapes.clinicMembership),
    authorizationCode: CloudDrive.shapes.authorizationCode,
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    isClientInitialized: PropTypes.bool.isRequired,
    route: App.shapes.route,
    // Implicit actions
    onFetchClinicMemberships: PropTypes.func,
    onFetchCustomIdentifiers: PropTypes.func,
    onFetchClinics: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func,
    onOpenModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        hcpClinicMemberships: Account.selectors.hcpClinicMemberships(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        clinicMemberships: selectors.clinicMemberships(state),
        approvingClinicMembershipId: selectors.approvingClinicMembershipId(state),
        authorizationCode: CloudDrive.selectors.authorizationCode(state),
        isClientInitialized: App.selectors.isClientInitialized(state),
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchClinicMemberships: (clinicId)=>dispatch(actions.fetchClinicMemberships(clinicId)),
        onFetchCustomIdentifiers: (countryId)=>dispatch(actions.fetchClinicCustomIdentifiers(countryId)),
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown()),
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId))
    });
const ConnectedClinicSettings = connect(mapStateToProps, mapDispatchToProps)(ClinicSettings);
export default withStyles(styles)(ConnectedClinicSettings);
